import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';
import { getCurrentInstance, inject } from 'vue';
import { useRouter } from 'vue-router';
export class ApplicationInsightsLogger {
    constructor(options) {
        var _a, _b, _c;
        const { instrumentationKey, userId } = options;
        this.appInsights = instrumentationKey
            ? new ApplicationInsights({
                config: {
                    instrumentationKey,
                },
            })
            : null;
        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.loadAppInsights();
        (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackPageView();
        if (userId) {
            (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.setAuthenticatedUserContext(userId);
        }
    }
    logPageView() {
        var _a;
        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackPageView();
    }
    logInformation(message) {
        var _a;
        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackTrace({ message, severityLevel: SeverityLevel.Information });
    }
    logWarning(message) {
        var _a;
        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackTrace({ message, severityLevel: SeverityLevel.Warning });
    }
    logError(message) {
        var _a;
        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackTrace({ message, severityLevel: SeverityLevel.Error });
    }
}
const APP_INSIGHTS_SYMBOL = Symbol('app insights');
export const appInsightsLoggerPlugin = {
    install: (app, options) => {
        const logger = new ApplicationInsightsLogger(options);
        app.config.globalProperties.$appInsightsLogger = logger;
        app.provide(APP_INSIGHTS_SYMBOL, logger);
    },
};
export const useAppInsightsLogger = () => {
    const instance = getCurrentInstance();
    if (!instance)
        throw new Error(`Can't inject logger without vue instance`);
    const logger = inject(APP_INSIGHTS_SYMBOL);
    const router = useRouter();
    router.afterEach(() => logger.logPageView());
    return logger;
};
